export default {
    language:'English',
    // 导航
	zdy:{
        tjsq: "Submit Application",
         czsl: "Recharge Quantity",
         enterczsl: "Please enter the recharge amount",
         cz:'Please enter the recharge amount{min}~{max}',
         qbdz: "Wallet Address",
         enterqbdz: "Please enter the wallet address",
        sftjmcj:"Whether to submit the order selling price",
        sftjmrj:"Whether to submit the order purchase price",
		proloss:'Stop loss',
	},
    header:{
        home:'home',
        markets:'Markets',
        fiat:'Fiat',
        c2c:'C2C',
        exchange:'Exchange',
        lever:'Lever',
        micro:'Second contract trading',
        myshop:"Shops",
        assets:'Assets',
        help:'Help',
        login:"Login",
        sign:'Sign Up',
        accountSet:'Account',
        tradeLog:'Transaction log',
        receiveSet:'Collection ',
        identify:'Authentication',
        jchange:'exchange',
        logout:'Logout',
        themedark:'Night mode',
        themeday:'Day Mode',
        bank:"Binding card"
    },
    // 登录注册
    lg:{
        login:'Login',
        register:'Sign Up',
    },
    // 首页
    home:{
        vol:'24H Vol',
        c01:"The world's leading digital asset trading platform",
        c02:'Deliver secure, trusted digital asset trading and asset management services to millions of users in more than 130 countries worldwide',
        c03:'Safe and trustworthy',
        c04:'5 years experience in digital asset financial services',
        c05:'Professional distributed architecture and anti-DDOS attack system',
        c06:'Global ecological layout',
        c07:'A number of countries set up localized transaction service centers ',
        c08:'to create a blockchain ecosystem with multiple business forms',
        c09:'Customer first',
        c10:'Establish a preemptive payment mechanism',
        c11:'Set up an investor protection fund',
        c12:'Multi-platform terminal trading anytime, anywhere',
        c13:'Covers multiple platforms of iOS, Android, Windows,and supports full business functions',
        sweep:'Scan code download',
        android:'Android',
        pinput:'Please enter your email or mobile number',
        atrade:'Register a ETHEREUM Global Station Account and Start the Trading Journey',
        download:"download App"
    },
    // 底部
    foo:{
        about:'About us',
        support:'User support',
        contact:'Contact us',
        qq:'QQ',
        email:'Email',
    },
    // 行情
    market:{
		handicap:"Handicap",
        exchange:'Exchange',
        selfmarket:'Favorites',
        allmarket:'All',
        symbol:'Pair',
        newprice:'Last Price',
        change:'Change',
        highprice:'High',
        lowprice:'Low',
        vol:'24H Vol',
    },
    // 公共交易
    td:{
        buy:'buy',
        sell:'sell',
        currency:'currency',
        num:'number',
        time:'time',
        limit:'limit',
        price:'Unit Price',
        method:'pay way',
        total:'Total',
        inwant:'Please input',
        do:'operation',
        more:'Load more',
        nomore:'No more',
        nodata:'No data',
        trade:'trade',
        buynum:'Purchase quantity',
        sellout:'Sell ',
        buyin:'Buy ',
        all:'all',
        allbuy:'Buy all',
        allsell:'Sell all',
        buytotal:'Please enter the total amount you want to purchase.',
        selltotal:'Please enter the total amount you want to sell.',
        buyallnum:'Please enter the quantity you want to buy.',
        sellallnum:'Please enter the quantity you want to sell.',
        tradeTotal:'Total transaction volume',
        doceil:'Automatically cancel in seconds',
        place:'Place an order',
        waitpay:'Pending payment',
        paycode:'Payment code',
        finished:'Completed',
        ceiled:'Cancelled',
        payed:'Paid',
        nofinish:'incomplete',   
        buyer:'Buyer',
        seller:'seller',
        callWay:'contact way',
        placeTime:'Order time',
        renum:'Reference number',
        canceil:'cancel',
        confirm:'confirm',
        pwd:'Please enter the transaction password.',
        coincode:'Monetary unit',
        pcoin:'Please choose monetary unit.'
    },
    // 法币交易
    fat:{
        // LegalPayDetail
        orderLog:'Order record',
        fatdLog:'legal trade record',
        shoper:'business',
        faLog:'legal trade record',
        tdType:'Transaction type',
        odStatus:'Order status',
        pwaitPay:'Please wait for the buyer to pay',
        odFinish:'The order has been completed',
        odCeil:'The order has been cancelled',
        odPay:'Payment has been made. Please check the payment information carefully.',
        tdCeil:'Cancel transaction',
        pCeil:'If you have paid , do not cancel it',
        paySure:'Payment confirm',
        pdopay:'Please confirm that you have paid',
        badClick:'Malicious clicks will freeze accounts directly',
        receivePay:'Receipt confirmation',
        payReceive:'Please confirm that the buyer has paid you.',
        receivePays:'Confirmation of receivables',
        // LegalPay
        payPlease:'Please pay',
        tdPrice:'Unit price',
        tdNum:'Transaction volume',
        payinfo:'Payment information',
        banknum:'Bank account',
        realName:'Real name',
        shoperZname:'Merchant sub branch',
        shoperNum:'Merchant account',
        odCeil:'Cancel order',
        imPay:'have paid, Confirm',
        // LegalSeller
        register_time:'Register time',
        odtotal:'Assembly sheet',
        odmonth:'30 days sheet',
        odfinish:'Completion sheet',
        odrate:'Completion rate',
        submit:'publish',
        phone:'phone',
        mysell:'My sale',
        mybuy:'My purchase',
        realAuth:'Real name authentication',
        advAuth:'Advanced authentication',
        linebuy:'Online purchase',
        linesell:'Sell online',
        tipPay:'Please contact the merchant for payment within 24 hours. If the payment exceeds 24 hours, it will be cancelled automatically.',
        notlow:'No less than the minimum limit',
        nothigh:'Do not exceed the maximum limit',
        notnum:'Do not exceed the maximum quantity',
        // LegalShopDetail
        type:'type',
        status:'status',
        seeOrder:'View order',
        withdraw:'withdraw',
        abnormal:'abnormal',
        lowershelf:'Lower shelf',
        protection:'Rights protection',
	    apply:'Apply rights protection',
        psType:'Please select the type',
        pselect:'Please choose',
        alipay:'Alipay',
        wechat:'WeChat',
        bank:'Bank card',
        minNum:'Minimum trading volume',
        maxNum:'Maximum trading volume',
        wantBuy:'want to buy',
        pnums:'Please enter quantity',
        pmin:'Please enter the minimum transaction volume',
        pmax:'Please enter the maximum trading volume',
        pnot:'Maximum trading volume should not be less than minimum trading volume',
        // MyLegalShops
        myshops:'personal stores',
        name:'Name',
        fiatSub:'Legal tender',
        shoper_balance:'Merchant balance',
        enterShop:'Enter shop',
        // shop_legal_pay_detail
        payedWait:'Payment made awaiting verification',
        yes:'YES',
        no:'NO',
        sd:'Lock in balance',
        journal:'Balance log',
        business:'business',
        user:'user',
        backdone:'Withdrawn',
        busbalance:'Merchant balance',
		userbalance:'User balance',
    },
    ctc:{
        ctc:'C2C',
        myRelease:'My release of C2C',
        myTrade:'C2C I traded',
        and:'yes',
        balance:'balance',
        buynum:'Buying vol',
        sellnum:'Selling vol',
        bankTransfer:'Bank transfer',
        payim:'Must pay by oneself',
        pbuyNum:'enter the purchase quantity',
        pprice:'Please enter unit price',
        payway:'Please choose the mode of payment.',
        psellNum:'Please enter the quantity sold.',
        suerePlace:'Do you confirm the order?',
        detail:'details',
        payinfo:'Payment information',
        Payee:'Payee',
        total:'Total',
        name:'name',
        cardnum:'Card number',
        receivePay:'Confirmation of receivables',
        ceilConfirm:'Confirm cancel the transaction?',
        paySeller:'Please confirm that you have paid the seller, malicious clicks will freeze the account.',
        payBuyer:'Please confirm that you have received payment information from the buyer.',
        account:'Account number',
        sellerPay:'Please confirm that the buyer has paid you?',
        payattion:'Please pay to the seller as soon as possible after payment confirmation, malicious clicks will directly freeze the account.',
        log:'c2c已完成订单'
    },
    // 合约
    lever:{
        nowentrust:'Open orders',
        hisentrust:'Order history',
        lvchi:'Leverage position',
        all:'all',
        or:'or',
        gotrade:'Start trading',
        tdrecord:'Transaction record',
        dealed:'Completed',
        notdeal:'No deal',
        loading:'Loading',
        entotal:'Total entrusted amount',
        canuse:'available ',
        std: 'Market',
        xtd: 'Limit',
        pprice: 'Please enter the price',
        phand: 'Please enter the number of purchases',
        phandsell:'Please enter the number of hands for sale',
        pwd: 'password',
        ppwd: 'Please enter the transaction password',
        psw: 'transaction password',
        equal: 'equal to',
        times: 'time',
        timed: 'multiple',
        hand: 'hand',
        hands: 'hands',
        ptimes: 'Please select multiples',
        phands: 'Please select the number of hands',
        contractVal: 'contract market value',
        bail: 'Margin',
        canBail: 'Available margin',
        charge: 'transaction service fee',
        domore: 'Buy (long)',
        doshort: 'sell (short)',
        dmore: 'Long',
        dshort: 'Short',
        sureOd: 'confirm order',
        noless: 'The number of hands cannot be lower than',
        nomore: 'The number of hands cannot be higher than',
        tdnum: 'Total',
        risk: 'risk rate',
        allloss: 'total position profit and loss',
        onehouse: 'One button closes',
        type: 'type',
        entrustPrice: 'commission price',
        openPrice: 'opening price',
        nowPrice: 'current price',
        styPrice: 'Take profit price',
        stsPrice: 'Stop Loss Price',
        openTime: 'open time',
        closeTime: 'closing time',
        rate: 'handling fee',
        nightFee: 'overnight fee',
        loss: 'profit and loss',
        setloss: 'Set stop loss stop loss',
        expectProfit: 'expected profit',
        expectLoss: 'expected loss',
        allClose: 'All closing',
        moreClose: 'Only flat more than one',
        nullClose: 'Only empty single',
        sureClose: 'Confirm the position? ',
        thanZearo: 'The value set must be greater than 0',
        listin: 'Pending order',
        tdin: 'in the transaction',
        closein: 'Close the position',
        closed: 'Closed',
        revoked: 'revoked',
        revokeOrder: 'Are you sure to cancel the order? ',
        ping:'Close the position',
        revoke:'Cancel',
        sureping:'Determine the closure?？',
        thanzone:'The value set must be greater than 0'
       
    },
    // 币币
    cuy:{
         direction: 'direction',
         total: 'total',
         price: 'price',
         sell: 'sell',
         buy: 'buy',
         allStation: 'Market trades',
         buyPrice: 'Price',
         buynum: 'Amount',
         sellPrice: 'Price',
         sellnum: 'Amount',
         tdPrice: 'Total',
         or:'or',
         tdStart: 'Start trading',
         pbPrice: 'Please enter the bid price',
         pbNum: 'Please enter the purchase amount',
         psPrice: 'Please enter the selling price',
         psNum: 'Please enter the sales amount',
         fixPrice: 'Limit',
         Mtrans: 'Market',
         available: 'available',
         revoke: 'Undo',
         loading: 'Loading',
         confirmCancel: 'Are you sure you want to cancel? ',
         confirm: 'OK',
         cancel: 'Cancel',
         nomore: 'No more data',
         evelPrice: 'Average Price'
     },
    // 资产
    asset:{
		confirmhuazhuan:"Do you confirm the transfer?",
        assets: 'assets',
        currency_account: 'coin account',
        lever_account: 'leverage account',
        fince_account: 'Fiat account',
        change_account: 'Transaction account',
        micro_account:'Second Contract Account',
        miscroAccount: 'Second Contract Account',
        assets_hua: 'Fund transfer',
        all_assets: 'total assets',
        currency: 'currency',
        canuse: 'available',
        frezz: 'freeze',
        conversion: 'Folding',
        charging: 'Deposit',
        withdraw: 'Withdraw',
        address_bind:'bind withdraw address',
        address_withdraw: 'Trading address management',
        record: 'record',
        tbrecord:'WithdrawRecord',
        address_charge: 'Charge address',
        address_width: 'Ticket Address',
        copy: 'copy',
        ercode: 'QR code',
        reminder: 'warm tips',
        notcharge: 'Do not recharge any of the above addresses',
        ornone: ', otherwise the asset will not be recovered',
        support: 'The coin only supports the simple send method. The use of other methods (send all) is temporarily unable to be credited. Please understand. ',
        minnum: 'the minimum number of coins{min}~{max}',
        ratenum: 'fee fee',
        havenum: 'number of arrivals',
        from: 'From',
        to: 'to',
        transfer: 'swiping',
        tfnum: 'the number of transfers',
        ptfnum: 'Please enter the lowest',
        dtfnum: 'the number of strokes',
        canbalance: 'available balance',
        sureConfirm: 'confirm transfer',
        moneyRecord: 'financial record',
        pNum: 'Please enter the number of transfers',
        leverUse: 'Leverage account available',
        legalUse: 'Fiat account available',
		changeUselg:'Coin accounts are available',
        changeUse: 'Transaction account available',
        microuse: 'Second contract account available',
        look: 'View',
        chargeRecord: 'charged currency record',
        status: 'Tracking status',
        noopen: 'This feature is not open yet',
        enterAdderses: 'Please enter the coin address',
        enterNum: 'Please enter the number of coins',
        lessMin: 'The number of coins entered is less than the minimum',
        tips01: 'Do not recharge any other assets to the above address, otherwise the assets will not be recovered. ',
        tips02: 'Currency only supports the simple send method, the use of other methods (send all) for the currency can not be accounted for temporarily, please understand. ',
        beizhu: 'Remarks',
        pbeizhu: 'Please enter a note',
        add: 'add',
        addressList: 'address list',
        delete: 'delete',
        norec: 'no record',
        selectCurrency: 'Please select currency',
        chainType:"Chain type",
        ThreeChannel:"Tripartite channel",
        AboutRate:"Exchange rate{rate}approximately equal to",
        OnlineBanking:"Online Banking",
        ScanCode:"Scan code"
    },
    // 账户设置
    set:{
        mycode2:'My authorization code',
        copycode2:'Copy authorization code',
        uaccont: 'Your account security level:',
        strong: 'strong',
        middle: '中中',
        weak: 'weak',
        min: 'low',
        heigh: 'high',
        complete: 'Complete more information to ensure account security',
        mycode: 'my invitation code',
        copycode: 'Copy invitation code',
        bindphone: 'Bind the phone',
        bindemail: 'Binding Mailbox',
        loginpwd: 'login password',
        noBind: 'unbound',
        binds: 'binding',
        bind: 'de bind',
        binded: 'bind',
        net: 'The Internet account is at risk of being stolen. It is recommended that you change your password periodically to protect your account. ',
        reset: 'Modify',
        setPsw: 'Set the transaction password to ensure transaction security. ',
        goSet: 'Go to set',
        bindAccount: 'Bind redemption account',
        duihuan: 'Bind the account to redeem points',
        copysuccess: 'Copy success',
        copyfail: 'copy failed',
        recopy: 'Please copy again',
        account: 'account',
        detail: 'details',
        val: 'amount',
        forgetPsw: 'Forgot password',
        code: 'verification code',
        getCode: 'Get code',
        setPsw: 'set password',
        enterPsw: 'Please enter a password',
        pswFalse: 'The passwords entered twice are inconsistent',
        enterPswagain: 'Please enter your password again',
        jsetPsw:'Set up the transaction password',
        jenterPsw:'Please enter the transaction password',
        jenterPswagain:'Please enter the transaction password again',
        enterAccount: 'Please enter an account',
        enterCode: 'Please enter the verification code',
        accountFalse: 'The phone or email account you entered does not meet the rules!',
        second: 'second',
        sendCode: 'send',
        sendsucc:'send success',
        enterPswTwo: 'Please enter the password twice',
        rest: 'remaining',
        yes: 'yes',
        no: 'no',
        yorn: 'Whether to Set Transaction Password',
    },
    // 身份认证
    auth:{
         identity: 'Authentication',
         name: 'name',
         idcard: 'identity document',
         upimg: 'Please upload a photo of the identity document, the first one is the front, the second one is the reverse side, and the third one is the front photo of the hand-held identity document. ',
         submit: 'submit',
         auditing: 'Audit...',
         certified: 'Certified!',
         pname: 'Please enter a name',
         pidcard: 'Please enter the ID number',
         pimg: 'Please upload a certificate picture!',
     },
    // 收款方式
    seting:{
         pmethod: 'payment method',
         truename: 'real name',
         opening: 'Bank name',
         bank: 'bank card number',
         alipay: 'Alipay account',
         wename: 'WeChat nickname',
         wechat: 'WeChat account',
         pname: 'Please enter your real name',
         popen: 'Please enter the name of the bank name',
         pcard: 'Please enter the bank card number',
         palipay: 'Please enter Alipay account',
         Pwname: 'Please enter the WeChat nickname',
         pwaccount: 'Please enter WeChat account',
         pimg1: 'Wechat collection code',
         pimg2: 'Alipay payment code'
     },
    // 帮助中心
    news:{
         seeall: 'View all',
         helpcenter: 'Help Center',
         back:'Return'

     },
    //登录
    login:{
        welcome: 'Welcome to login',
        phoneLogin: 'Mobile',
        emailLogin: 'Mailbox',
        account: 'account',
        psw: 'password',
        login: 'login',
        nouser: 'Not a user of ETHEREUM? ',
        goRegister: "Register now and start trading on the world's leading digital asset trading platform",
        registerFree: 'free registration',
        psw6: "Password can't be less than six"
    },
    register:{
        register: 'Register',
        phoneRegister: 'Mobile',
        emailRegister: 'mailbox',
        country: 'nationality',
        enterPhone: 'Please enter the phone number',
        enterEmail: 'Please enter the mailbox',
        psw16: 'The password is between 6-16',
        inviteCode: 'Invitation Code',
        sel: 'Must fill',
        sel2:'not required',
        read: 'I have read and agree',
        xieyi: 'User Agreement',
        tips01: 'Do not modify the nationality information after registration, please be sure to choose it. ',
        tips02: 'Verification emails may be misidentified as spam, please check. ',
        tips03: 'Please save your ETHEREUM account and login password. ',
        tips04: 'Do not use the same login password as other websites. ',
        emailFalse: 'The mailbox you entered does not match the rule'
    },
    // 积分兑换
    jc:{
        title:'JC Convertible Digital Assets BEAU Platform',
        balance:'balance',
        cannum:'Available JC Quantity',
        new:'Latest Price',
        exnum:'Exchange Quantity',
        pnum:'Please enter JC number',
        canex:'Convertible BEAU Quantity',
        exnow:'E xchange',
        record:'Exchange Record',
        exprice:'Exchange price',
        extime:'Exchange time',
        not:'The number of available integrals is insufficient',
        usenum:'Use JC Quantity',
        out:'Exit',
        gotd:'To trade'
    },
    coin:{
        manage: 'Financial',
        total: 'total deposit',
        bao: 'deposit money',
        mybao: 'my deposit',
        profit: 'estimated revenue',
        cuntime: 'deposit time',
        endtine: 'due time'
    },
    team:{
        myteam:'my team',
        ztnum: 'direct push number',
        activenum: 'number of active team members',
        profit: 'revenue',
        back: 'return commission',
        cblog: 'charging record',
        bblog: 'currency record',
    },
    // k线
    kline: {
        text1: 'Time',
        text2: '1min',
        text3: '5min',
        text4: '15min',
        text5: '30min',
        text6: '1hour',
        text7: '1day',
        text8: '1week',
        text9: '1mon',
    },
    // 秒合约
    miscro: {
        trade: 'Transaction',
        buyPrice: 'Purchase price',
        finshPrice: 'Transaction price',
        loss: 'Estimated profit and loss',
        times: 'Count down',
        mode: 'Transaction mode',
        num: 'Opening quantity',
        rate: 'Profit rate',
        up: 'Buy up',
        down: 'Buy or fall',
        openNum: 'Please enter the opening quantity',
        success: 'Success in placing orders!',
        c2c: "fiat account",
        complaint: "Complaint suggestion",
        reply: "Please write down your questions and we will reply to you as soon as possible...",
        complaintList: "Complaint Suggestion List",
        complaintReply: "Reply:",
        complaintDescription: "Please enter a description",
        resetpwd: "Modify password",
        foundedOn: "Founded on",
        commonProblem: "Common problem",
        statement: "Interpretative statement",
        about: "About ETHEREUM",
        everyone: "Everyone is CEO",
        program: "ETHEREUM Global Partners Program",
        program2: "Partners",
        myMine: "My mine:",
        friend: "My mine friend:",
        myRank: "My rank:",
        accumulated: "Accumulated commission:",
        copyLinks: "Copy",
        moneyVein: "People's relationship changes into money vein",
        example: "Example of commission",
        enterQuantity: "Please enter quantity",
        contractBalance: "Contract account balance",
        submitRepeatedly: "In submission, please do not submit repeatedly",
        alipayCode: "Alipay payment code",
        wechatCode: "Wechat Receipt Code",
        realPrice: "Real time price",
        currencyExchange: "Currency exchange",
        currencyExchangeIn: "Currency exchange",
        cashableBalance: "Cashable balance：",
        minimumCashable: "Minimum Cashable：",
        maximumCashable: "Maximum Cashable：",
        automaticallys: "After clicking on the exchange, it will be automatically completed and cannot be returned.",
        match:"Match",
        title:"Asset convertibility",
        holdAssets:"Holding assets",
        dangerousCurrency:"Holding dangerous currency",
        convertibleQuantity:"Convertible Quantity",
        currencyExchanges:"Currency exchange rate：",
        insuranceCurrency:"Insurance currency",
        insuranceType:"Insurance type",
        contractAsset:"Contract Asset Insurance",
        warehouses:"Number of Warehouses",
        availableAssets:"Available assets:",
        insuredAssets:"Insured assets:",
        insuredAssets1:"Insured assets",
        insuranceAssets:"Insurance assets:",
        purchaseInsurance:"Purchase insurance",
        insuranceClaims:"Insurance claims",
        insuranceCancellation:"Insurance cancellation",
        coinWallet:"Insurance Coin Wallet",
        bmbWallet:"HAP Wallet",
        cumulativeCoins:"Cumulative coins：",
        availableQuantity:"Available Quantity:",
        rawCurrency:"Record of raw currency",
        contractInsurance:"Contract insurance",
        tenThousand:"ten thousand",
        runningLow:"Sorry, your credit is running low",
        purchase:"The quantity you enter does not conform to the rules. Your purchase quota is",
        reach:"reach",
        between:"between",
        onlyEnter:"You can only enter",
        integersBetween:"Integers between",
        notReturned:"Click to purchase insurance, as a detailed understanding of the insurance treaty and agree that the warehouse will automatically enter into force, can not be returned.",
        settled:"When the insured assets lose money and cannot place an order, the insurance claims shall be settled.",
        profitable:"When assets are profitable",
        terminated:"at that time, the insurance will be automatically terminated.",
        automatically:"When the insured assets lose 50%, they must apply for insurance claims, otherwise they cannot be traded. When the profits are 100%, the insurance will automatically cancel the contract. The warehouse can only pay twice a day, more than twice, t+1.",
        termination:"After the termination of the insurance contract, the insured assets can be converted. After the termination of the contract, the insured assets are deemed to be in breach of contract, and the warehouse is cleared automatically.",
        just:"just",
        back:"back",
        lowestNumber:"The lowest number is",
        confirmExchange:"Do you confirm the exchange?",
        contractValuation:"Valuation of Contract Account Assets",
        secondValuation:"Second Contract Account Asset Valuation",
        falshValuation:"Valuation of assets in flash account",
        c2cValuation:"Asset Valuation of fiat Account",
        recordWithdrawal:"Record of withdrawal of money",
        category:"category",
        safetyCenter:"Safety Center",
        safeText1:"Registration, password modification, and security settings for receiving validated SMS",
        safeText2:"Internet accounts are at risk of being stolen. It is recommended that you change your password regularly to protect account security.",
        flashTrading:"Flash Trading",
        assetCenter:"Asset Center",
        promotionCode:"My Promotion Code",
        loginAgain:"Logon is out of date, please login again",
        text10:"Real-time Price Based on HAP",
        text11: "Authorization Code"


    },
    bank:{
        BindingCard:"Bind bank card",
        name:"Name",
        PayeeName:"Name of payee",
        bankName:"Bank name/Bank code",
        PayeeAdd:"Payment address",
        submit:"Submit",
        fee:"Collection",
        selectBank:"Please select a bank"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js